import { IEntity } from '../types';
import { EntityService } from './EntityService';

export class RiskAppIncidentImpactTypeService extends EntityService<IEntity> {
    constructor() {
        super(`/RiskAppIncidentImpactTypes`);
    }
}
